import { useGetTopics } from "../../../api/queries";
import { ModuleI, ModuleStatus } from "../../../types";
import Spinner from "../../../componentLibrary/Spinner";
import { ErrorDisplay } from "../../../utils/ErrorHandling";
import TopicCard from "./TopicCard";

export default function TopicCardGrid() {
  const {
    data: modules,
    isLoading,
    isError,
    error,
  } = useGetTopics(undefined, ModuleStatus.Published);

  if (isLoading) return <Spinner className="mx-auto" />;
  if (isError || !modules)
    return <ErrorDisplay error={error} messageSource="api" />;

  if (modules.length === 0) {
    return (
      <div className="rounded-xl border border-gray-200 bg-white p-4">
        <div className="py-4 text-center">
          <p className="text-sm text-gray-400 py-2">
            No topics are available yet. Check back soon.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      {modules.map((module: ModuleI) => (
        <TopicCard key={module._id} module={module} />
      ))}
    </div>
  );
}
